'use strict';

import Vue from 'vue';
import axios from 'axios';
import { ParseResultType, parseDomain } from 'parse-domain';

let serviceUrl = process.env.VUE_APP_BASE_URL || process.env.apiUrl || '';
let serviceUrl2 = process.env.VUE_APP_BASE_URL2 || process.env.apiUrl || '';
if (process.env.NODE_ENV != 'development') {
  const parseResult = parseDomain(window.location.hostname);

  if (parseResult.type === ParseResultType.Listed) {
    const { domain, topLevelDomains } = parseResult;
    const topLevel = topLevelDomains.join('.');
    serviceUrl = `https://services.${domain}.${topLevel}`;
    serviceUrl2 = `https://dashboard.${domain}.${topLevel}`;
  }
}

const config = {
  baseURL: serviceUrl,
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // allow credentials to be send, including cookies in the request header
  crossorigin: true,
};

const _axios = axios.create(config);

const config2 = {
  baseURL: serviceUrl2,
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // allow credentials to be send, including cookies in the request header
  crossorigin: true,
};

const _axios2 = axios.create(config2);

// const AUTH_TOKEN = localStorage.getItem('token');
// if (AUTH_TOKEN) {
//   _axios.defaults.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`;
//   _axios2.defaults.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`;
// }

const AxiosPlugin = {} as any;

AxiosPlugin.install = function (Vue: any) {
  Vue.axios = _axios;
  (window as any).axios = _axios;

  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });

  Vue.axios2 = _axios2;
  (window as any).axios2 = _axios2;

  Object.defineProperties(Vue.prototype, {
    axios2: {
      get() {
        return _axios2;
      },
    },
    $axios2: {
      get() {
        return _axios2;
      },
    },
  });
};

Vue.use(AxiosPlugin);

export default AxiosPlugin;
